import './Card.css'
import {formatCurrency} from '../../utility/formatCurrency'
//defining the props, e.g., name should be string, etc.
type CardProps = {
  name: string,
  price: number,
  image: string,
  category: string,
  instructor:{name: string};
}

//declaring and calling the props defined in the Card component.
const Card = (props: CardProps) => {
  return (
    <div className="CourseCard">
      
      <img src={props.image} alt={props.name} className='courseImg' />
      <h1 className='CourseName'>{props.name}</h1>
      <p className='CourseInstructor'>By {props.instructor.name}</p>
      <div className='CourseCategory'>
        <p className='CourseCategoryText'>{props.category}</p>
      </div>
      <p className='CoursePrice'>{formatCurrency(props.price)}</p>
    </div>
  )
}

export default Card
